import { TrackingLoader } from "@utilities/tracking/TrackingLoader";
import { UserProvider } from "context/user";
import { parse } from "flatted";
import "../styles/fonts.scss";
import "../styles/tailwind.css";
import "../styles/global.scss";

export default function MyApp({ Component, pageProps }) {
  const page = pageProps.safeJson ? parse(pageProps.safeJson) : null;
  function iOS() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(window.navigator.platform) ||
      // iPad on iOS 13 detection
      (window.navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  const isIos = typeof window !== "undefined" && iOS();
  if (
    typeof window !== "undefined" &&
    page?.pageContent?.component === "pdfAsset" &&
    isIos
  ) {
    window.location.href = `https:/${page?.pageContent.pdf.fields.file.url}`;
  }

  return page?.pageContent?.component === "pdfAsset" ? (
    isIos ? (
      <div className="pdfWaitScreen"></div>
    ) : (
      <iframe
        title="pdfAsset"
        src={page?.pageContent.pdf.fields.file.url}
        width="100%"
        style={{ height: "100vh" }}
      ></iframe>
    )
  ) : (
    <>
      <TrackingLoader />
      <UserProvider>
        <Component {...pageProps} />
      </UserProvider>
    </>
  );
}
